import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

const createCoursePricingPolicy = (
  course_id: string,
  version: number,
  pricingPolicy: {
    type: 'smartPrice' | 'discount' | 'override' | ''
    code: string
    valueType: 'fixed' | 'percentage'
    value: number
    initialValue?: number | null
    isActive: boolean
    allowCourseDiscounts: boolean
    allowDiscountsForGifts: boolean
    showOriginalPrice: boolean
    maxUsage: string
    startDate: Date | null | string
    expiryDate: Date | null | string
    disablePrevious?: boolean
  }
) => {
  return new Promise((resolve, reject) => {
    const tokenId = Cookies.get(AUTH_TOKEN_KEY)
    const URL = routes.COURSE + course_id + '/' + version + '/pricing-policies'
    const config = {
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
    }
    const data = { ...pricingPolicy }

    if (!data.disablePrevious) {
      delete data.disablePrevious
    }
    AxiosClient.post(URL, data, config)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
export default createCoursePricingPolicy
